import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import helpers from 'app/helpers/grant-system';

const {StageTypes} = helpers;

class WorkflowCols extends React.PureComponent {

  constructor(props) {
    super(props);

  }

  get stagesGroups() {
    const stages = [...(this.props.workflow?.stages || [])];
    if (!stages) return [];
    const g2 = stages.splice(-1, 1);
    return [stages, g2];
  }

  render() {
    const {workflow, className, minColWidth, renderBelow, renderAbove} = this.props;
    const {stagesGroups} = this;

    return (
      <div className={`ca-gwf-cols ${className}`}>
        <div className="ca-gwf-cols-stages-con">
          {stagesGroups.map((stages, gi) => {
            return (
              <div className="ca-gwf-cols-stages" key={gi} style={{flex: stages.length}}>
                {stages.map((stage, si) => {
                  const isFinal = [StageTypes.SYSTEM_APPROVED, StageTypes.SYSTEM_DECLINED].includes(stage.type);
                  return (
                    <div key={stage.id} className="ca-gwf-cols-stage" style={{minWidth: minColWidth}}>
                      {!!renderAbove && renderAbove(stage, workflow)}
                      <div className={`ca-gwf-cols-stage-bar`} style={{backgroundColor: (stage.color || '#333')}}>
                        {!isFinal && (<>
                          <div className={`ca-gwf-cols-stage-bar-caret1`} />
                          <div className={`ca-gwf-cols-stage-bar-caret2`} style={{borderLeftColor: (stage.color || '#333')}} />
                        </>)}
                        <div className="ca-gwf-cols-stage-bar-title">{stage.title}</div>
                      </div>
                      {!!renderBelow && renderBelow(stage, workflow)}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

}

WorkflowCols.propTypes = {
  workflow: PropTypes.object.isRequired,
  className: PropTypes.string,
  minColWidth: PropTypes.number,
  renderBelow: PropTypes.func,
  renderAbove: PropTypes.func,
};
WorkflowCols.defaultProps = {
  className: '',
  minColWidth: 240,
  renderBelow: null,
  renderAbove: null,
};

export default WorkflowCols;
